var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"snackbar-container"},[_vm._t("default",function(){return [_vm._v("Test text")]},{"close":_vm.close}),_c('IconClose',{staticClass:"icon-close",on:{"click":function($event){return _vm.$emit('close')}}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }